import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export function ProductCardSkeleton() {
  return (
    <Card className="py-0 gap-0 group overflow-hidden border-none rounded-md shadow-[2px_4px_4px_rgba(0,0,0,0.25)] lg:shadow-[2px_4px_6px_rgba(0,0,0,0.35)]">
      {/* Image Skeleton */}
      <div className="aspect-square w-full">
        <Skeleton className="w-full h-full bg-gray-100 rounded-none" />
      </div>

      <CardContent className="p-2.5 sm:p-4">
        {/* Title */}
        <Skeleton className="h-4 sm:h-5 w-3/4 mb-1.5 bg-gray-100 rounded-sm" />
        
        {/* Description (desktop only) */}
        <div className="hidden sm:block space-y-1.5 mb-2">
          <Skeleton className="h-3 w-full bg-gray-100 rounded-sm" />
          <Skeleton className="h-3 w-5/6 bg-gray-100 rounded-sm" />
        </div>

        {/* Meta (weight / shelf life) */}
        <Skeleton className="h-3 w-1/2 mb-3 bg-gray-100 rounded-sm" />

        {/* Price */}
        <Skeleton className="h-5 sm:h-6 w-1/3 mb-3 bg-gray-100 rounded-sm" />

        {/* Button */}
        <Skeleton className="h-8 sm:h-10 w-full bg-gray-100 rounded-md" />
      </CardContent>
    </Card>
  );
}
